import Rating from "@mui/material/Rating";
import styled from "styled-components";

export const StyledRating = styled(Rating)`
  & .MuiRating-iconFilled {
    color: #36bba0;
  }
`;
